<div class="row margin-0">

  <div class="col-md-12 padding-left-0 padding-right-0 margin-bottom-5 landing-nav-sticky">
    <div class="hpanel">
      <div class="mainNav panel-body border-radius-top-left-right-6">
        <div class="navIteam" *ngIf="allConnect ">
          <h6>All Member Networks: <span> {{count||0}}</span></h6>
        </div>
        <div class="navIteam" *ngIf=" connect">
          <h6>Active Contacts : <span> {{count||0}}</span></h6>
        </div>
        <div class="navIteam" *ngIf="requestrecived">
          <h6>Requests Received : <span> {{count||0}}</span></h6>
        </div>



        




        <!-- <div class="navIteam" *ngIf="requestsent">
          <h6>Requests Sent : <span> {{count||0}}</span></h6>
        </div> -->
        <div class="navIteam pos-rel-10">
          <input #txt (input)="keyupdata(txt.value)" type="text" class="form-control input-sm pd-lt-10 search-field-pad"
            placeholder="Search Member Network" aria-label="Amount (to the nearest dollar)" [(ngModel)]="searchContent"
            name="searchadmin" id="searchadmin" />
          <ng-icon name="tablerSearch" class="pos-rel-25"></ng-icon>
        </div>
        <div class="navIteam connectionbtn">
          <div
            class="btn-group"
            dropdown
            container="body"
            placement="bottom right">

            <!-- Single button -->
            <button
              type="button"
              class="btn primary-btn filter-single-btn"
              dropdownToggle
              data-toggle="dropdown">

              <span>{{ btnnameshow }}</span>
              <ng-icon name="tablerFilter"></ng-icon>

            </button>

            <!-- Dropdown options -->
            <ul
              class="dropdown-menu  no-padding dropdown-menu-right leftview"
              *dropdownMenu
              role="menu">

              <li role="menuitem">
                <a
                  class="dropdown-item"
                  [class.selected]="statusList === null"
                  (click)="filterstatus(null)">
                  All
                </a>
              </li>

              <li role="menuitem">
                <a
                  class="dropdown-item"
                  [class.selected]="statusList === 'CONNECTED'"
                  (click)="filterstatus('CONNECTED')">
                  Active Contacts
                </a>
              </li>

              <li role="menuitem">
                <a
                  class="dropdown-item"
                  [class.selected]="statusList === 'PENDING'"
                  (click)="filterstatus('PENDING')">
                  Requests Received
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Member network-->
  <div class="col-sm-75 col-md-75 col-lg-75 padding-left-0 padding-right-5">

    <ng-container *ngIf=" loadAPIcall">
      <div class="col-md-6 col-lg-3 padding-left-0 padding-right-5" style="margin-bottom: 5px;"
        *ngFor="let n of [1, 2, 3, 4, 5, 6, 7, 8]">
        <app-common-skeleton [NameOftheScreen]="'usercard'"></app-common-skeleton>
      </div>
    </ng-container>

    <ng-container *ngIf="!loadAPIcall && (connectionlistuserdata | async)?.length  > 0">
      <div class="col-md-6 col-lg-3 padding-left-0 padding-right-5" style="margin-bottom: 5px;"
        *ngFor="let data of (connectionlistuserdata | async) | customFilter:{userName: searchKey}: false">
        <app-b2bnetwork-card [businessDetails]="businessDetails" [From]="'MEMBER_NETWORK'"
          (updateNetworkList)="refreshmemberNetworklist($event)" [BusinessDataInput]="data"></app-b2bnetwork-card>
        <!-- <app-membernetwork-card [BusinessDataInput]="data" [button]="'PRIMARY'"
        (updateNetworkList)="refreshmemberNetworklist($event)"></app-membernetwork-card> -->
      </div>
    </ng-container>

    <app-nodata-found [title]="noDatafound" *ngIf="showNoDatafound"></app-nodata-found>
  </div>


  <div class="col-sm-25 col-md-25 col-lg-25 padding-left-0 padding-right-0 landing-sticky-widget">
    <div class="">
      <app-common-widget [page]="'NETWORK_PAGE'" [inputData]="'NETWORK'" [userType]="'ALL'"></app-common-widget>
    </div>
  </div>

  <div class="col-sm-8 gs-end-of-list" *ngIf="stopScroll && (connectionlistuserdata | async)?.length  > 0"
    style="text-align: center; padding-top: 1rem;">
    <div class="col-sm-12">
      <!-- <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon> -->
      <ng-icon name="tablerCircleCheck"></ng-icon>

    </div>
    <div class="col-sm-12">
      <p class="biase">You've reached the bottom of the page</p>
    </div>
  </div>
</div>
<div infiniteScroll [infiniteScrollDistance]="1" [scrollWindow]="true" [infiniteScrollThrottle]="1000"
  (scrolled)="onScrollDown()"></div>